import ApiService from "../api";

export default class FluigService extends ApiService {

    constructor() {
        super(`/api/fluig/compras`);
    }

    listaTodos(dataInicial, dataFinal) {
        return this.get(`/lista-solicitacoes?dataInicial=${dataInicial}&dataFinal=${dataFinal}`);
    }

    exportarExcel(dataInicial, dataFinal) {
        return this.getFile(`/lista-solicitacoes/exportar?dataInicial=${dataInicial}&dataFinal=${dataFinal}`);
    }

    countMaioresSolicitantes(dataInicial, dataFinal) {
        return this.get(`/resumo-maiores-solicitantes?dataInicial=${dataInicial}&dataFinal=${dataFinal}`);
    }

    resumoPorStatus(dataInicial, dataFinal) {
        return this.get(`/resumo-status?dataInicial=${dataInicial}&dataFinal=${dataFinal}`);
    }

    resumoPorFases(dataInicial, dataFinal) {
        return this.get(`/resumo-fase?dataInicial=${dataInicial}&dataFinal=${dataFinal}`);
    }

    resumoPorFilial(dataInicial, dataFinal) {
        return this.get(`/resumo-filial?dataInicial=${dataInicial}&dataFinal=${dataFinal}`);
    }

    resumoPorPrioridade(dataInicial, dataFinal) {
        return this.get(`/resumo-prioridade?dataInicial=${dataInicial}&dataFinal=${dataFinal}`);
    }

    resumoPorPrioridadeFilial(dataInicial, dataFinal) {
        return this.get(`/resumo-filial-prioridade?dataInicial=${dataInicial}&dataFinal=${dataFinal}`);
    }

    resumoPorProduto(dataInicial, dataFinal) {
        return this.get(`/resumo-produto?dataInicial=${dataInicial}&dataFinal=${dataFinal}`);
    }

    resumoPorDepartamento(dataInicial, dataFinal) {
        return this.get(`/resumo-departamento?dataInicial=${dataInicial}&dataFinal=${dataFinal}`);
    }

    resumoDiferencaCotacao(dataInicial, dataFinal) {
        return this.get(`/resumo-diferenca?dataInicial=${dataInicial}&dataFinal=${dataFinal}`);
    }

    resumoTempoAtividades(dataInicial, dataFinal) {
        return this.get(`/resumo-tempo-atividades?dataInicial=${dataInicial}&dataFinal=${dataFinal}`);
    }

    resumoMediaDias(dataInicial, dataFinal) {
        return this.get(`/resumo-media-tempo?dataInicial=${dataInicial}&dataFinal=${dataFinal}`);
    }

    buscaValorGasto(dataInicial, dataFinal) {
        return this.get(`/valor-gasto?dataInicial=${dataInicial}&dataFinal=${dataFinal}`);
    }
}
